import React from 'react';

import ClientsPlanning from '../../components/Admin/ClientsPlanning';

function ClientsPlanningView() {
  return (
    <ClientsPlanning />
  );
}

export default ClientsPlanningView;
